import React from 'react';

export const Typing = () => (
  <div className="bubble-row bot" data-testid="typing-indicator">
    <div className="bubble bot typing" aria-label="escribiendo">
      <span />
      <span />
      <span />
    </div>
  </div>
);

export const Bubble = ({ from = 'bot', html, agente, wa = false }) => (
  <div className={`bubble-row ${from}`} data-testid={from === 'user' ? 'bubble-user' : 'bubble-bot'}>
    <div className={`bubble ${from}`}>
      <div dangerouslySetInnerHTML={{ __html: String(html).replace(/\n/g, '<br/>') }} />
      {wa ? (
        <span className="wa-meta">
          {new Date().toLocaleTimeString('es-CO', { hour: '2-digit', minute: '2-digit' })}
          {from === 'user' ? <b className="wa-check">✓✓</b> : null}
        </span>
      ) : null}
    </div>
  </div>
);
